import { render } from "./WPdfViewer.vue?vue&type=template&id=2bbdb158&scoped=true&ts=true"
import script from "./WPdfViewer.vue?vue&type=script&lang=ts"
export * from "./WPdfViewer.vue?vue&type=script&lang=ts"

import "./WPdfViewer.vue?vue&type=style&index=0&id=2bbdb158&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbdb158"]])

export default __exports__